import { Languages } from '@/components/LanguageSelector/types.ts'
import isLanguageSupported from '@/utils/isLanguageSupported.ts'
import i18next from 'i18next'

const DEFAULT_LOCALE = Languages.EN

const localeByPrefix: Record<string, Languages> = {
  pt: Languages.PTBR,
  en: Languages.EN,
  es: Languages.ES,
}

export function resolveLocale(language?: string): Languages {
  if (!language) return DEFAULT_LOCALE
  if (isLanguageSupported(language)) return language as Languages

  const prefix = language.split('-')[0].toLowerCase()

  return localeByPrefix[prefix] ?? DEFAULT_LOCALE
}

export function getLocaleFromPathname(pathname: string): Languages {
  const segment = pathname.split('/')[1] ?? ''

  return isLanguageSupported(segment)
    ? (segment as Languages)
    : resolveLocale(navigator.language)
}

export function applyLocale(locale: Languages) {
  const language: string = locale

  if (document.documentElement.lang !== language) {
    document.documentElement.lang = language
  }

  if (i18next.language !== language) {
    void i18next.changeLanguage(language)
  }
}
